module.exports = __webpack_public_path__ + "media/images/emblems/GW-GL-Glarus_Nord-f349d499871cddcb89eb156eb0044c59.png";